import { string } from 'prop-types';
import React from 'react';

function DialPad({ fill, ...props }) {
  return (
    <svg
      height={24}
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      viewBox="-2 -2 22 22"
      width={24}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.25 3.9375C3.18198 3.9375 3.9375 3.18198 3.9375 2.25C3.9375 1.31802 3.18198 0.5625 2.25 0.5625C1.31802 0.5625 0.5625 1.31802 0.5625 2.25C0.5625 3.18198 1.31802 3.9375 2.25 3.9375Z"
        fill="none"
      />
      <path
        d="M9 3.9375C9.93198 3.9375 10.6875 3.18198 10.6875 2.25C10.6875 1.31802 9.93198 0.5625 9 0.5625C8.06802 0.5625 7.3125 1.31802 7.3125 2.25C7.3125 3.18198 8.06802 3.9375 9 3.9375Z"
        fill="none"
      />
      <path
        d="M15.75 3.9375C16.682 3.9375 17.4375 3.18198 17.4375 2.25C17.4375 1.31802 16.682 0.5625 15.75 0.5625C14.818 0.5625 14.0625 1.31802 14.0625 2.25C14.0625 3.18198 14.818 3.9375 15.75 3.9375Z"
        fill="none"
      />
      <path
        d="M2.25 10.6875C3.18198 10.6875 3.9375 9.93198 3.9375 9C3.9375 8.06802 3.18198 7.3125 2.25 7.3125C1.31802 7.3125 0.5625 8.06802 0.5625 9C0.5625 9.93198 1.31802 10.6875 2.25 10.6875Z"
        fill="none"
      />
      <path
        d="M9 10.6875C9.93198 10.6875 10.6875 9.93198 10.6875 9C10.6875 8.06802 9.93198 7.3125 9 7.3125C8.06802 7.3125 7.3125 8.06802 7.3125 9C7.3125 9.93198 8.06802 10.6875 9 10.6875Z"
        fill="none"
      />
      <path
        d="M15.75 10.6875C16.682 10.6875 17.4375 9.93198 17.4375 9C17.4375 8.06802 16.682 7.3125 15.75 7.3125C14.818 7.3125 14.0625 8.06802 14.0625 9C14.0625 9.93198 14.818 10.6875 15.75 10.6875Z"
        fill="none"
      />
      <path
        d="M9 17.4375C9.93198 17.4375 10.6875 16.682 10.6875 15.75C10.6875 14.818 9.93198 14.0625 9 14.0625C8.06802 14.0625 7.3125 14.818 7.3125 15.75C7.3125 16.682 8.06802 17.4375 9 17.4375Z"
        fill="none"
      />
    </svg>
  );
}
DialPad.propTypes = {
  fill: string.isRequired
};

export default DialPad;
